exports = module.exports = require("./../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".media-object{display:table;margin-bottom:2em;overflow:hidden;table-layout:fixed;width:100%}.media-image,.media-object img{display:table-cell;vertical-align:middle;width:20%}.media-text{display:table-cell;padding-left:1em;vertical-align:top;width:80%}.media-text header a{text-decoration:none}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./~/postcss-loader!./app/src/App/components/stylesheets/MediaObject.scss
// module id = 447
// module chunks = 0